"use client";

import { useTranslation } from "react-i18next";

export default function Submitted() {
  const { t } = useTranslation("common");
  return (
    <div className="flex flex-col items-center min-h-screen gap-6 mt-8 mb-8">
      <h1 className="text-3xl mb-3">
        {t("applicationSubmitted.title")}
      </h1>

      <p className="text-lg">
        {t("applicationSubmitted.message")}
      </p>

      <p className="text-lg">
        {t("applicationSubmitted.timeline")}
      </p>

      <p className="text-md text-gray-700">
        {t("applicationSubmitted.footer")}
      </p>
    </div>
  );
}